import { Button } from '@cian/ui-kit/button';
import { Header3, InlineText2 } from '@cian/ui-kit/typography';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './MotivationConsultantPopup.css';

interface IMotivationPopupContent {
  title: string;
  text: string;
  buttonText: string;
}

interface IMotivationConsultantPopupProps {
  content: IMotivationPopupContent;
  onClick(): void;
  onClose(): void;
}

export function MotivationConsultantPopup({ content, onClick, onClose }: IMotivationConsultantPopupProps) {
  const { title, text, buttonText } = content;

  return (
    <div className={classNames(styles['container'], styles['hands-ver1'])}>
      <div className={styles['close']} onClick={onClose}>
        <IconActionClose16 />
      </div>
      <Header3 whiteSpace="pre">{title}</Header3>
      <div className={styles['text']}>
        <InlineText2 whiteSpace="pre-line">{text}</InlineText2>
      </div>
      <Button theme="fill_primary" size="XS" onClick={onClick} fullWidth>
        {buttonText}
      </Button>
    </div>
  );
}
